module.exports = __webpack_public_path__ + "img/columbia-100_d03b5fa09d0716aa0ee324d1ebf8c4a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/columbia-100.jpg
// module id = 285
// module chunks = 0